export * from './current-user-header';
export * from './notification-bell';

import { CurrentUserHeaderComponent } from './current-user-header';
import { NotificationBellComponent } from './notification-bell';

export const LayoutMolecules = [
    CurrentUserHeaderComponent, NotificationBellComponent
]